var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "con-btn" },
    [
      _c("div", { staticClass: "row-content mb10 mt10" }, [
        _c("div", { staticClass: "row-item column-layout flex" }, [
          _c("div", { staticClass: "fl col-3" }, [
            _c("span", [_vm._v("员工名称：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.thisStaffName || "无"))]),
            _vm._v(" "),
            _vm.isSkip
              ? _c(
                  "a",
                  {
                    staticClass: "swb-btn  swb-btn-link",
                    on: {
                      click: function($event) {
                        _vm.staffForselect()
                      }
                    }
                  },
                  [_vm._v("选择")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fl col-3" }, [
            _c("span", [_vm._v("员工所在公司：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.thisComName || "无"))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fl col-3" }, [
            _c("span", [_vm._v("被订阅公司：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.thisComName || "无"))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fl col-3" }, [
            _vm.thisStaffId != null
              ? _c(
                  "a",
                  {
                    staticClass: "swb-btn  swb-btn-link",
                    on: {
                      click: function($event) {
                        _vm.showSubscrList()
                      }
                    }
                  },
                  [_vm._v("查看已订阅")]
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.bizTopicList, function(bizTopic) {
        return _c("div", { staticClass: "msg-subscr-msanage" }, [
          bizTopic.bizEventMsgList != null &&
          bizTopic.bizEventMsgList.length > 0
            ? _c("div", [
                _c("div", { staticClass: "message-tips" }, [
                  _c(
                    "div",
                    { staticClass: "inline-block mr20" },
                    [
                      _c("span", { staticClass: "font-gray1" }, [
                        _vm._v("主题：")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function($event) {
                              _vm.selectBizTopicMethod(bizTopic.id)
                            }
                          },
                          model: {
                            value: bizTopic.checked,
                            callback: function($$v) {
                              _vm.$set(bizTopic, "checked", $$v)
                            },
                            expression: "bizTopic.checked"
                          }
                        },
                        [_vm._v(_vm._s(bizTopic.name))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "inline-block mr20" },
                    [
                      _c("span", [_vm._v("商品分类：")]),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function($event) {
                              _vm.goodsCatSet(bizTopic.id)
                            }
                          },
                          model: {
                            value: bizTopic.goodsCatForAll,
                            callback: function($$v) {
                              _vm.$set(bizTopic, "goodsCatForAll", $$v)
                            },
                            expression: "bizTopic.goodsCatForAll"
                          }
                        },
                        [_vm._v("全部分类")]
                      ),
                      _vm._v(" "),
                      !bizTopic.goodsCatForAll
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.goodsCatForselect(bizTopic.id)
                                }
                              }
                            },
                            [_vm._v("选择")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "inline-block mr20" },
                    [
                      _c("span", [_vm._v("服务分类：")]),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function($event) {
                              _vm.servcCatSet(bizTopic.id)
                            }
                          },
                          model: {
                            value: bizTopic.servcCatForAll,
                            callback: function($$v) {
                              _vm.$set(bizTopic, "servcCatForAll", $$v)
                            },
                            expression: "bizTopic.servcCatForAll"
                          }
                        },
                        [_vm._v("全部分类")]
                      ),
                      _vm._v(" "),
                      !bizTopic.servcCatForAll
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.servcCatForselect(bizTopic.id)
                                }
                              }
                            },
                            [_vm._v("选择")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                (bizTopic.goodsCatList != null &&
                  bizTopic.goodsCatList.length > 0) ||
                (bizTopic.servcCatList != null &&
                  bizTopic.servcCatList.length > 0)
                  ? _c("div", [
                      bizTopic.goodsCatList != null &&
                      bizTopic.goodsCatList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "pb10" },
                            [
                              _c("span", [_vm._v("已选商品分类：")]),
                              _vm._v(" "),
                              _vm._l(bizTopic.goodsCatList, function(goodsCat) {
                                return _c(
                                  "span",
                                  { staticClass: "mr10 mb10" },
                                  [_vm._v(_vm._s(goodsCat.catName))]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      bizTopic.servcCatList != null &&
                      bizTopic.servcCatList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "pb10" },
                            [
                              _c("span", [_vm._v("已选服务分类：")]),
                              _vm._v(" "),
                              _vm._l(bizTopic.servcCatList, function(servcCat) {
                                return _c(
                                  "span",
                                  { staticClass: "mr10 mb10" },
                                  [_vm._v(_vm._s(servcCat.catName))]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "message-body" }, [
                  _c(
                    "ul",
                    { staticClass: "native-table" },
                    [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _vm._l(bizTopic.bizEventMsgList, function(bizEventMsg) {
                        return _c(
                          "li",
                          {
                            staticClass: "table-tr",
                            class:
                              bizEventMsg.vipLevel > _vm.currentVipLevel
                                ? "vipCtrl"
                                : ""
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "table-td",
                                staticStyle: { "text-align": "left" }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    staticClass: "ml20",
                                    attrs: {
                                      disabled:
                                        bizEventMsg.vipLevel >
                                        _vm.currentVipLevel
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.selectEventMsg(
                                          bizTopic.id,
                                          bizEventMsg.id
                                        )
                                      }
                                    },
                                    model: {
                                      value: bizEventMsg.checked,
                                      callback: function($$v) {
                                        _vm.$set(bizEventMsg, "checked", $$v)
                                      },
                                      expression: "bizEventMsg.checked"
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(bizEventMsg.name))
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "table-td",
                                staticStyle: { "text-align": "left" }
                              },
                              [_vm._v(_vm._s(bizEventMsg.renderContent))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "table-td",
                                staticStyle: { "text-align": "left" }
                              },
                              [
                                bizEventMsg.siteMsgFlag
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            staticClass: "ml20",
                                            attrs: {
                                              disabled:
                                                bizEventMsg.vipLevel >
                                                _vm.currentVipLevel
                                            },
                                            on: { change: _vm.changeSaveFlag },
                                            model: {
                                              value:
                                                bizEventMsg.selectSiteMsgFlag,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  bizEventMsg,
                                                  "selectSiteMsgFlag",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "bizEventMsg.selectSiteMsgFlag"
                                            }
                                          },
                                          [_vm._v("站内信")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                bizEventMsg.emailFlag
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            staticClass: "ml20",
                                            attrs: {
                                              disabled:
                                                bizEventMsg.vipLevel >
                                                _vm.currentVipLevel
                                            },
                                            on: { change: _vm.changeSaveFlag },
                                            model: {
                                              value:
                                                bizEventMsg.selectEmailFlag,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  bizEventMsg,
                                                  "selectEmailFlag",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "bizEventMsg.selectEmailFlag"
                                            }
                                          },
                                          [_vm._v("邮件")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                bizEventMsg.wxFlag
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            staticClass: "ml20",
                                            attrs: {
                                              disabled:
                                                bizEventMsg.vipLevel >
                                                _vm.currentVipLevel
                                            },
                                            on: { change: _vm.changeSaveFlag },
                                            model: {
                                              value: bizEventMsg.selectWxFlag,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  bizEventMsg,
                                                  "selectWxFlag",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "bizEventMsg.selectWxFlag"
                                            }
                                          },
                                          [_vm._v("微信")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                bizEventMsg.selectWxFlag
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            staticClass: "ml20",
                                            attrs: {
                                              disabled:
                                                bizEventMsg.vipLevel >
                                                _vm.currentVipLevel
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.setMiniAppInfo(
                                                  bizTopic.id,
                                                  bizEventMsg.id
                                                )
                                              }
                                            },
                                            model: {
                                              value: bizEventMsg.selectMiniApp,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  bizEventMsg,
                                                  "selectMiniApp",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "bizEventMsg.selectMiniApp"
                                            }
                                          },
                                          [_vm._v("选择小程序")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                bizEventMsg.selectMiniApp &&
                                bizEventMsg.selectWxFlag
                                  ? _c("div", { staticClass: "inline-block" }, [
                                      bizEventMsg.bizEventMsgAppList != null &&
                                      bizEventMsg.bizEventMsgAppList.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "inline-block ml10"
                                            },
                                            [
                                              _c(
                                                "el-radio-group",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      bizEventMsg.vipLevel >
                                                      _vm.currentVipLevel
                                                  },
                                                  on: {
                                                    change: _vm.changeSaveFlag
                                                  },
                                                  model: {
                                                    value: bizEventMsg.appAlias,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        bizEventMsg,
                                                        "appAlias",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "bizEventMsg.appAlias"
                                                  }
                                                },
                                                _vm._l(
                                                  bizEventMsg.bizEventMsgAppList,
                                                  function(eventMsgApp) {
                                                    return _c(
                                                      "el-radio",
                                                      {
                                                        attrs: {
                                                          label:
                                                            eventMsgApp.appAlias
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .miniAppAliases[
                                                                eventMsgApp
                                                                  .appAlias
                                                              ]
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "font-red ml10" },
                                            [_vm._v("未设置小程序")]
                                          )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            : _vm._e()
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "a",
          {
            staticClass: "swb-btn swb-btn-small",
            on: { click: _vm.saveEventMsgSubscr }
          },
          [_vm._v("保存")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        {
          staticClass: "table-th",
          staticStyle: { width: "150px", "text-align": "left" }
        },
        [_vm._v("消息名称")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-th", staticStyle: { "text-align": "left" } },
        [_vm._v("消息内容")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-th", staticStyle: { width: "700px" } }, [
        _vm._v(" ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b487841", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b487841","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/bizMsg/SubscrManageList.vue
// module id = 3133
// module chunks = 1